import { Program } from '../../Reports/NewReportDialog';

export const formatPercentageNumber = (n: number) =>
  Number.isInteger(n) ? n : n.toFixed(2);

export interface InvestmentQuestionOption {
  optionText: string;
  nextQuestionId: number | undefined;
}

export interface InvestmentQuestion {
  questionId: number;
  questionText: string;
  options: InvestmentQuestionOption[];
}

export interface InvestmentAnswer {
  question: InvestmentQuestion;
  answer: string | string[];
  optionIndex: number;
}

export interface InvestmentSplitWithAnswers {
  program?: Program;
  percentage: string | number;
  amount: string | number;
  year?: number | string;
  answers: InvestmentAnswer[];
}

interface AllocationRecords {
  [programId: number]:
    | {
        [year: number]: number[] | undefined;
      }
    | undefined;
}

export const getAllocationStates = (
  investmentSplit: InvestmentSplitWithAnswers[],
  totalAmount: number,
): {
  isAllocationRecordsValid: boolean;
  allocationRecords: AllocationRecords;
  allocationAmountState: 'success' | 'error' | undefined;
} => {
  let isAllocationRecordsValid = true;
  let totalAllocatedAmount = 0;

  const record: AllocationRecords = {};
  investmentSplit.forEach((item, index) => {
    totalAllocatedAmount = totalAllocatedAmount + Number(item.amount);
    const programId = item.program?.Id;
    const year = item.year;
    if (programId && year) {
      if (!record[programId]) {
        record[programId] = {};
      }
      const programRecord = record[programId]!;
      if (!programRecord[year]) {
        programRecord[year] = [];
      }
      const yearRecord = programRecord[year]!;
      yearRecord.push(index);
      if (yearRecord.length > 1) {
        isAllocationRecordsValid = false;
      }
    }
  });
  return {
    isAllocationRecordsValid,
    allocationRecords: record,
    allocationAmountState:
      totalAllocatedAmount === totalAmount
        ? 'success'
        : totalAllocatedAmount > totalAmount
        ? 'error'
        : undefined,
  };
};

export const isAllocationRecordValid = (
  allocationRecords: AllocationRecords,
  program: Program | undefined,
  year: number | undefined,
): boolean => {
  if (!program || !year) return true;
  if (
    !allocationRecords[program.Id] ||
    !allocationRecords[program.Id]![year] ||
    !allocationRecords[program.Id]![year]?.length ||
    allocationRecords[program.Id]![year]!.length < 2
  ) {
    return true;
  }
  return false;
};
